<template>
  <div class="filters-wrapper">
    <div class="filters-heading">
      <h3>
      {{translate("offLandingTitle")}}
      <span v-if="place"> {{translate("offLandingTitleVariable", null, place)}}</span>
      </h3>
    </div>
    <div class="filters-list">
      <OffersLocationFilter
        v-on:filterLocation = "updateRegion($event)"
        :selected-region="selectedRegion"
        :main-icon-size="isMobileIcons ? 'xs' : 'sm'"
      />
      <OffersDatesFilter
        data-testid="offers-dates-filter"
        :main-icon-size="isMobileIcons ? 'xs' : 'sm'"
        :selected-dates-range="selectedDatesRange"
        @datesChange="emitDatesChange"
      />
      <MoreFiltersBtn
        data-testid="open-more-filters-btn"
        @click="emitOpenMoreFilters"
        :counter="moreFiltersCounter"
        icon-only
        mobile-only
      />
    </div>
  </div>
</template>

<script>
import { media } from '@/infrastructure/Utils'
import { mapGetters } from 'vuex'
import OffersLocationFilter from '@/components/offers/filters/OffersLocationFilter'
import OffersDatesFilter from '@/components/offers/filters/OffersDatesFilter'
import MoreFiltersBtn from '@/components/filters/MoreFiltersBtn'

export default {
  name: 'OffersFilters',
  emits: ['datesChange', 'openMoreFilters'],
  components: {
    OffersLocationFilter,
    OffersDatesFilter,
    MoreFiltersBtn
  },
  props: {
    selectedRegion: {
      type: [String, Array],
      required: false,
      default: ''
    },
    selectedDatesRange: {
      type: Object,
      required: true
    },
    moreFiltersCounter: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data() {
    return {
      isMobileIcons: false,
      place: ''
    }
  },
  computed: {
    ...mapGetters('newOffers', ['isSeeAllFilterEurope'])
  },
  created() {
    window.addEventListener('resize', this.handleResize)
  },
  mounted() {
    this.handleResize()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    emitDatesChange(payload) {
      this.$emit('datesChange', payload)
    },
    handleResize() {
      this.isMobileIcons = window.innerWidth <= media('tablet-l')
    },
    emitOpenMoreFilters() {
      this.$emit('openMoreFilters')
    },
    updateRegion(location) {
      if (!this.isSeeAllFilterEurope) {
        this.place = location
        this.$store.dispatch('newOffers/setPlace', location)
      }
    }
  }
}
</script>

<style lang="scss">
// TODO: Move to global

.btn-tertiary {
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
  border-radius: 100rem;
  padding: 2rem 2.5rem;
  line-height: 2rem;
  background-color: color('white');
  color: color('dark-grey');
  border: 1px solid color('grey-cool-two');
  width: 100%;

  &.border-dark {
    border: 1px solid color('dark-grey');
  }

  @media (max-width: media('tablet-l')) {
    padding: 0.8rem 1.2rem;
    min-width: inherit;
    max-width: inherit;
    max-height: 4rem;
    height: 4rem;
  }
}

.btn-inline {
  padding: 0 !important;

  i {
    margin: 0 !important;
  }
}

// --------------------

.filters-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 3rem;
  padding-bottom: 3rem;

  @media (max-width: media('tablet-l')) {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .filters-heading {
    font-size: 2.5rem;
    color: color('black');
    margin-bottom: 3rem;

    @media (max-width: media('tablet-l')) {
      display: none;
    }
  }

  .filters-list {
    display: grid;
    gap: 2rem;
    height: auto;
    grid-template-columns: 1fr 1fr;
    justify-content: center;

    @media (max-width: media('tablet-l')) {
      gap: 1rem;
      grid-template-columns: 1fr 1fr auto;
      width: 100%;
    }
  }
}

.dates-heading-wrapper,
.location-heading-wrapper {
  position: relative;
  height: inherit;
  width: inherit;

  span {
    white-space: nowrap;
    overflow: hidden;
    height: 100%;
    text-overflow: ellipsis;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    padding-top: 2px;
    text-align: left;

    @media (max-width: media('tablet-l')) {
      padding-top: 0;
    }
  }
}

.select-location-btn-wrapper,
.select-dates-btn-wrapper {
  position: relative;
  min-width: 280px;

  @media (max-width: media('tablet-l')) {
    min-width: auto;
  }

  .btn-tertiary {
    height: 100%;

    .btn-toggle-datepicker,
    .btn-toggle-location {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      gap: 1rem;
    }
  }

  .clear-dates-icon {
    color: color('grey-cool-two');
  }
}
</style>
